import { HttpHeaders, HttpParams } from "@angular/common/http";
import { Router } from "@angular/router";
import {
  Component,
  OnInit,
  TemplateRef,
  ViewChild,
  ElementRef,
} from "@angular/core";
import {
  FormBuilder,
  FormControl,
  FormGroup,
  Validators,
} from "@angular/forms";
import { ActivatedRoute } from "@angular/router";
import { NgbModal, ModalDismissReasons } from "@ng-bootstrap/ng-bootstrap";
import { ServiciosService } from "src/app/core/services/servicios.service";
import { IntegracionServices } from "src/app/core/services/integraciones.service";
import { FileUploadComponent } from "src/app/shared/components/file-upload/file-upload.component";
import { ServicioModel } from "src/app/models/Servicio.model";
import { lastValueFrom, takeUntil, Subject } from "rxjs";
import Swal, { SweetAlertIcon } from "sweetalert2";

import { TableAction } from "src/app/shared/components/table-paginator/table-paginator.component";
import { k } from "src/environments/properties";

@Component({
  selector: "app-servicio",
  templateUrl: "./servicio.component.html",
  styleUrls: ["./servicio.css"],
})
export class ServiciosComponent implements OnInit {
  selectedFiles: File | File[] | FileList | null = null;
  currentItems: ServicioModel[] = []; // Los datos para la página actual
  private destroy$ = new Subject<void>();

  lotesPorFirmar: any[] = [];
  totalItemsLotesPorFirmar: any = 0;

  public formServicios: FormGroup;
  idServicio: string = "";
  public closeResult: string = "";

  spinner: boolean = false;
  toast = Swal;
  formServiciosIsSubmited = false;

  firmaGuardada: boolean = false;
  ocultarFirmaGuardada: boolean = false;

  constructor(
    private seriviciosServices: ServiciosService,
    private fb: FormBuilder,
    private modalService: NgbModal,
    private integracionServices: IntegracionServices,
    private route: ActivatedRoute,
    private router: Router,
  ) {}

  async ngOnInit() {
    this.toastAlert();
    this.initUserForm();
    this.route.paramMap
      .pipe(takeUntil(this.destroy$)) // Desuscribe automáticamente al destruir el componente
      .subscribe(async (params) => {
        const id = params.get("id");

        if (id) {
          this.showServicio(id);
        }
      });
  }

  ngAfterViewInit(): void {}

  initUserForm(): void {
    this.formServicios = this.fb.group({
      nombre: ["", [Validators.required, Validators.minLength(3)]],
      nombre_corto: ["", [Validators.required, Validators.minLength(3)]],
      auth_url: ["", [Validators.required, Validators.minLength(3)]],
      base_url: ["", [Validators.required]], // Ejemplo de longitud mínima
      auth_username: ["", [Validators.required]],
      auth_password: ["", [Validators.required]],
    });
  }

  async editarServicio() {
    this.formServiciosIsSubmited = true;
    if (!this.formServicios.valid) {
      this.formServicios.markAllAsTouched();
      return false;
    }

    const datos = { ...this.formServicios.value };
    delete datos.nombre_corto;
    if (this.firmaGuardada) {
      delete datos.auth_password;
    }

    const response = await lastValueFrom(
      this.seriviciosServices.editarServicio(datos, this.idServicio),
    );
    this.alert("success", "Éxito!", "Servicio Registrado!");
    this.formServiciosIsSubmited = false;
  }

  async showServicio(id: string) {
    this.idServicio = id;
    this.ocultarFirmaGuardada = true;
    this.firmaGuardada = true;
    const response = await lastValueFrom(
      this.seriviciosServices.showServicios(id),
    );
    const servicio = response.body;

    if (!servicio) return;
    this.onChangeFirmaGuardada();
    this.formServicios.patchValue({
      nombre: servicio.nombre,
      nombre_corto: servicio.nombre_corto,
      auth_url: servicio.authUrl,
      base_url: servicio.baseUrl,
      auth_username: servicio.authUsername,
    });
  }

  openModalContent(
    content: any,
    mode: boolean,
    size: "sm" | "lg" | "xl" = "lg",
    windowClass?: string,
  ) {
    this.modalService
      .open(content, {
        ariaLabelledBy: "modal-basic-title",
        size,
        centered: true,
        windowClass,
      })
      .result.then(
        (result) => {
          this.closeResult = `Closed with: ${result}`;
        },
        (reason) => {
          this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
        },
      );
  }

  private getDismissReason(reason: any): string {
    if (reason === ModalDismissReasons.ESC) {
      return "by pressing ESC";
    } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
      return "by clicking on a backdrop";
    } else {
      return `with: ${reason}`;
    }
  }

  onChangeFirmaGuardada() {
    const passwordControl = this.formServicios.get("auth_password");

    if (this.firmaGuardada) {
      passwordControl?.clearValidators();
      passwordControl?.setValue("******************");
    } else {
      passwordControl?.setValidators([Validators.required]);
      passwordControl?.setValue("");
    }

    passwordControl?.updateValueAndValidity();
  }

  toastAlert() {
    this.toast = Swal.mixin({
      toast: true,
      position: "top-end",
      showConfirmButton: false,
      timer: 3000,
      timerProgressBar: true,
      didOpen: (toast) => {
        toast.onmouseenter = Swal.stopTimer;
        toast.onmouseleave = Swal.resumeTimer;
      },
    });
  }

  alert(icontext: SweetAlertIcon, title: string, text: string = "") {
    this.toast.fire({
      icon: icontext,
      title: title,
      text: text,
    });
  }
}
